import React, { useState, useEffect } from "react";
import Layout from "../component/Layout";
import SubLayout from "../component/SubLayout";
import Header from "../component/Header";
import Container from "../component/Container";
import SmallLoader from "../component/SmallLoader";
import classes from "./SubscribePage.module.css";
import { v4 as uuidv4 } from "uuid";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getSubStatusApi, loginApi } from "../http/http";
import { service, serviceDetail } from "../utils/constant";
import { useDispatch, useSelector } from "react-redux";
import { setUserDetails } from "../store/slices/userSlice";
import { toast } from "react-toastify";
import { FaCopyright } from "react-icons/fa6";
import { useTranslation } from "react-i18next";

const LoginPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [msisdn, setMsisdn] = useState(
    searchParams.get("mn") ? searchParams.get("mn") : "",
  );
  const [loginLoading, setLoginLoading] = useState(false);
  const navigate = useNavigate();
  const [extRef, setExtRef] = useState(null);
  const dispatch = useDispatch();

  const { t } = useTranslation();

  const { userDetails } = useSelector((state) => state?.persisted?.userSlice);

  useEffect(() => {
    if (userDetails?.token) {
      navigate("/home");
    }
  }, [userDetails]);

  useEffect(() => {
    if (searchParams.get("ext_ref")) {
      setExtRef(searchParams.get("ext_ref"));
    } else {
      setSearchParams({ ext_ref: uuidv4() });
    }
  }, [searchParams]);
  const handleFormSubmission = async (e) => {
    e.preventDefault();
    if (msisdn?.trim().length === 0) {
      return;
    }

    if (msisdn.length >= 8) {
      setLoginLoading(true);

      // await loginApi(msisdn).then((res) => {
      //   dispatch(setUserDetails(res?.data))
      //   console.log(res?.data,'r');
      //   navigate("/home");
      //   // window.location.href = '/home'
      // })
      await getSubStatusApi({ mobileNumber: parseInt(msisdn) })
        .then((res) => {
          if (res.responseCode === 200) {
            dispatch(setUserDetails(res?.data));
            window.location.href = "/home";
          } else if (res.responseCode === 203) toast.error(t("lowbalance"));
          else if (res.responseCode === 202)
            toast.info(t("inprocess")); //Charging in process;
          else if (res.responseCode === 204)
            toast.error(t("158")); //Not subscribed
          else toast.error(t("128"));
        })
        .catch((err) => {
          console.log(err);
          toast.error(t("128"));
        })
        .finally(() => setLoginLoading(false));
    }
    else {
      toast.error(t("invalidNumber"));
    }
  };

  return (
    <Layout>
      <SubLayout>
        <Header hide={true} />
        <Container>
          <h1 className={classes.heading}>
            <span className={classes.highlight}>{t("0")} </span>
            {t("1")}
          </h1>

          <div className={classes.actions_box_container}>
            <div className={classes.actions_box}>
              <button
                className={`${classes.action_box} ${classes.active}`}
                type="button"
              >
                {t("2")}
              </button>
              <button
                className={`${classes.action_box}`}
                onClick={() => navigate(`/?mn=${msisdn}`)}
              >
                {t("3")}
              </button>
            </div>
          </div>

          <form className={classes.form} onSubmit={handleFormSubmission}>
            <div className={classes.username_field_form}>
              <div className={classes.country_code}>
                <img
                  src={
                    "/assets/images/" + serviceDetail[service]?.flag + ".svg"
                  }
                  //src={"https://flagcdn.com/" + serviDetail[service]?.flag + ".svg"}
                  alt="flag"
                  className={classes.flag}
                />
                <p className={classes.country_code_number}>
                  +{serviceDetail[service]?.countryCode}
                </p>
              </div>
              <input
                id="msisdn"
                name="msisdn"
                type="number"
                onWheel={(e) => e.target.blur()}
                autoFocus
                placeholder={t("4")}
                className={classes.input_field_username}
                onChange={(e) => {
                  setMsisdn(
                    e.target.value && e.target.value.trim().length <= 10
                      ? e.target.value.trim()
                      : e.target.value.trim().slice(0, 10),
                  );
                }}
                value={
                  msisdn && msisdn.trim().length > 10
                    ? msisdn.trim().slice(3)
                    : msisdn
                }
              />
            </div>

            <div className={classes.check_box_container}>
              <input
                type="checkbox"
                id="terms"
                name="Terms & Conditions"
                value="Terms"
                className={classes.check_box}
                checked
                readOnly
              ></input>
              <label className={classes.check_box_label}>
                <a href="/tnc">
                  <span className={classes.terms_conditions}>
                    {t("privacy")}
                  </span>
                </a>
              </label>
            </div>

            <button
              type="submit"
              disabled={loginLoading}
              className={classes.login_btn}
            >
              {loginLoading ? (
                <SmallLoader style={{ border: "5px solid #fff" }} />
              ) : (
                t("2")
              )}
            </button>

            {/* <div className={classes.footer}> */}
            {/* </div> */}
          </form>

          {/* <div className={classes.footer_container}>
                        <FaCopyright className={classes.copyright_icon} />
                        <p className={classes.copyright_text}>
                            UVCANN SOLUTIONS LLP
                            </p>
                    </div> */}
        </Container>
      </SubLayout>
    </Layout>
  );
};

export default LoginPage;
